import EsgEmailAlert from './EsgEmailAlert'

export default EsgEmailAlert
